<template>
    <div id="app">

        <transition :name="transitionName">
            <keep-alive>
                <router-view :class="{stop:!isTransition}" v-if="$route.meta.keepAlive" />
            </keep-alive>
        </transition>

        <transition :name="transitionName">
            <router-view :class="{stop:!isTransition}" v-if="!$route.meta.keepAlive" />
        </transition>

        <!--<div id="brtmap" class="fixed"></div>-->

        <transition name="fade-scale">
            <div class="app-preload" v-if="$store.state.appLoad===1">
                <div class="comm-icon">
                    <div class="logo">
                        <img src="./../public/images/logo.png" />
                    </div>

                    <div class="progress">
                        <div class="rail">
                            <i :style="{'width':loadProgress + '%'}"></i>
                        </div>
                        <div class="txt">{{loadProgress + '%'}}</div>
                    </div>

                </div>
            </div>

            <div class="app-preload1" v-if="$store.state.appLoad===2">
                <div class="comm-icon">
                     <div class="comm"></div>
                     <div class="icon"></div>
                </div>
            </div>
        </transition>


        <!--登录模块-->
        <Login v-model="loginVisible" :saveOpen="loginSave"></Login>

        <Share v-model="shareVisible"></Share>

        <!--  逃生通道-->
        <div class="escape-fixed" v-if="escapeFixed">
            <div class="wrap">
                <div class="box" @click="goEscape">
                    <i class="iconfont icon-jinjitaosheng"></i>
                    开启紧急逃生<br>通道
                </div>
                <div class="iconfont icon-close-02" @click="cancelEscape"></div>
            </div>
        </div>

        <!--逃生通知-->
        <div class="escape-message-fixed" v-if="escapeMsgFixed">
            <div class="wrap">
                <div class="t"><i class="iconfont icon-jinjitaosheng"></i></div>
                <div class="c">请前往首页<br>开启紧急逃生通道</div>
                <div class="b" @click.stop="escapeMsgFixed = false">知道了</div>
            </div>
        </div>

        <!--车位占用提示-->
        <div class="parking-ocupy-fixed" v-if="$BRT.parkNoInfo && parkingVisible">

            <div class="wrap">

                <div class="c-box">
                    <i class="iconfont icon-weixiao-"></i>
                    <p class="p1">深圳国际会展中心温馨提醒您：</p>
                    <p class="p2">{{$BRT.parkNoInfo.POI_ID}}车位已被占用，是否需要重新推荐</p>
                </div>

                <div class="b-box">
                    <a @click="cancelParking">否</a>
                    <a @click="goParking">是</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import { mapState } from "vuex"
    import { Login } from '@/modules/login'
    import { Share } from '@/modules/share'
    import {getEscapeRoute,getQueryParking} from "./config/prepare"
    import { getPoiInfo } from "./views/map/modules/brtmap/Brtmap";
    import {getAudioSrcFromText} from "./utils/util";

    export default {
        name: 'App',
        data() {
            return {
                transitionName: '',
                loginVisible:false,
                shareVisible:'',
                loginSave:0,

                isTransition:false, //取消首次切换动画

                preload:false,

                escapeFixed:false,
                escapeMsgFixed:false,

                parkingVisible:false,

                transitionTime:2000,   //加载时间
                loadProgress:0      //加载进度
            }
        },

        created(){

            //其他地方使用
            this.bus.$off('LoginCallback');
            this.bus.$on('LoginCallback',(res)=>{
                if(res.status == 1){
                    this.loginVisible = true;

                    if(res.save){   //登录保存
                        this.loginSave = res.save
                    }

                }else{
                    this.loginVisible = false;
                }
            });


            //其他地方使用
            this.bus.$on('shareCallback',(res)=>{

                if(res.status == 1){

                    // console.log('res.shareInfo',res.shareInfo);
                    let $shareInfo = {},

                    $sign = sessionStorage.getItem('sign');

                    if(res.shareInfo){

                        $shareInfo.title = res.shareInfo.NAME ? res.shareInfo.NAME : '无名地址';
                        $shareInfo.title +=' ';
                        $shareInfo.title += res.shareInfo.FLOOR_NAME ? res.shareInfo.FLOOR_NAME : '';

                        $shareInfo.desc = '好友分享了【'+this.$mapStore.plugInfo.plugInfo.name+'】室内地图位置，点击查看';

                        $shareInfo.imgUrl = this.$mapStore.plugInfo.plugInfo.plugInSettings.shareIcon;

                        $shareInfo.link = window.location.href.split('?')[0]+'?sign='+$sign+'&poiId='+res.shareInfo.POI_ID;

                        $shareInfo.poiId = res.shareInfo.POI_ID;

                        if(res.shareInfo.POI_ID == 'location'){ //当前位置
                            $shareInfo.link = window.location.href.split('?')[0]+'?sign='+$sign+'&poiId=location&LABEL_X='+
                                res.shareInfo.LABEL_X+'&LABEL_Y='+res.shareInfo.LABEL_Y+'&FLOOR_NUMBER=' + res.shareInfo.FLOOR_NUMBER;
                        }

                    }else{

                        $shareInfo.title = this.$mapStore.plugInfo.plugInfo.name;
                        $shareInfo.desc = '好友分享了此场景室内地图应用，一键导航、寻店、寻人等，点击查看';
                        $shareInfo.imgUrl = this.$mapStore.plugInfo.plugInfo.plugInSettings.shareIcon;
                        $shareInfo.link = window.location.href.split('?')[0] + '?sign='+$sign;

                    }

                    // alert(JSON.stringify($shareInfo));
                    // console.log('$shareInfo',$shareInfo);

                    //预置分享信息
                    if(this.$systemEnviron != 3){   //wx

                        if(this.$systemEnviron === 1)this.shareVisible = true;

                        this.bus.$emit('share_config',$shareInfo);

                    }else{  //app模拟wx

                        this.wx.share(JSON.stringify($shareInfo));

                    }


                }else{
                    this.shareVisible = false;
                }
            });

            //开启逃生通道
            this.bus.$off('eacapeBUS');
            this.bus.$on('eacapeBUS',state=>{
                if(state === 1){
                    //开启逃生通道
                    this.escapeEvent()
                }
            });


            //轮询访问分配车位状态
            this.bus.$off('APP.ParkingStateQuery');
            this.bus.$on('APP.ParkingStateQuery',res=>{

                let queryState = ()=>{

                    setTimeout(()=>{

                        let parkNoInfo = this.$BRT.parkNoInfo;

                        if(parkNoInfo){

                            getQueryParking(parkNoInfo.POI_ID,(query,err)=>{

                                if(err){
                                    this.$message.info(query);
                                    return;
                                }

                                if(query){
                                    //车位未被占用
                                    queryState();
                                }

                                else{
                                    //车位被占用
                                    this.parkingVisible = true;

                                    //导航中
                                    if(this.$mapStep.type =='toNAVING'){

                                        $VAR.$nav._$voice.pause();

                                        setTimeout(()=>{
                                            getAudioSrcFromText({text:"车位已被占用，是否重新推荐"},(audio,err)=>{
                                                if(!err)audio.play();
                                            })
                                        },300)

                                    }
                                    else{
                                        getAudioSrcFromText({text:"车位已被占用，是否重新推荐"})
                                    }

                                }

                            })
                        }
                    },10000)
                };

                queryState();

            })
        },

        methods: {
            getRouteIndex ($r) {

                let $rs = this.$router.options.routes;

                for (let i = 0; i < $rs.length; i++) {
                    if ($rs[i].name === $r.name && $rs[i].path === $r.path) {
                        return i;
                    }
                }

                return 0;
            },

            escapeEvent(){

                let map = $VAR.map,
                    start = this.brtmap.$locate.point;

                if(!start){
                    this.$message.info('逃生通道需定位后才可开启');
                    return;
                }

                map.requestRoute(start,'',res=>{

                        //先移除路径
                        map.resetRoute();

                        //拿取实际终点
                        let end = res.end,
                            xy = map.lnglatToCoords(end),
                            point = map.project(end);

                        let poi = getPoiInfo(this.brtmap,point,1200);

                        if(!poi){
                            poi = getPoiInfo(this.brtmap,point,1);
                        }

                        if(!poi)poi = {};

                        if(poi){

                            poi.LABEL_X = xy.x;
                            poi.LABEL_Y = xy.y;
                            poi.floor = end.floor;
                            poi.NAME = '逃生通道';

                            let floorInfo = map.getFloorInfoByIndex(end.floor);

                            floorInfo = Object.assign(floorInfo,{
                                FLOOR_NUMBER:floorInfo.floorNumber,
                                FLOOR_NAME:floorInfo.floorName,
                                FLOOR_ID:floorInfo.floorID
                            })

                            poi = Object.assign({},poi,floorInfo);

                            this.brtmap.$route.isExitPoint = Object.assign({},poi);
                            this.escapeFixed = true;

                        }

                        else{
                            this.$message.info('无法规划逃生路线,请稍候再试');
                        }
                    },

                    err=>{
                        this.$message.info('无法规划逃生路线,请稍候再试');
                    },

                    {
                        vehicle:false,
                        isExit:true,
                        ignore:['150013'],
                        sameFloorFirst:true
                    })
            },

            goEscape(){

                let start = this.brtmap.$locate.point,
                    poi = this.brtmap.$route.isExitPoint;
                //开启规划
                this.brtmap.$route.isExit = true;
                this.brtmap.$selecte.startPoint = Object.assign({},start);
                this.brtmap.$selecte.endPoint = Object.assign({},poi);

                this.escapeFixed = false;

                this.$mapStep.type = 'planRoute';
                this.bus.$emit('startAndEnd',{type:0});
            },

            cancelEscape(){
                this.brtmap.$route.isExitPoint = '';
                this.escapeFixed = false;
            },

            closeShare(){
                this.shareVisible = false;
            },

            cancelParking(){

                this.parkingVisible = false;
                this.$BRT.parkNoInfo = '';

            },

            goParking(){

                this.parkingVisible = false;
                this.$BRT.parkNoInfo = '';
                this.$router.replace('/parking');

            }

        },

        components:{
            Login,
            Share
        },

        computed:{
            ...mapState({
                brtmap:state=>state.mapStore.brtmap
            })
        },

        watch: {

            '$route' (to, from) {

                let toIndex = this.getRouteIndex(to),
                    fromIndex = this.getRouteIndex(from);

                //保存上一路由参数
                this.$BRT.lastRoute = from.path == '/' ? '' : from.path;

                //保存上两级路由(特殊处理)
                // if(to.path.match('/details/') && from.path !='/storelist'){this.$BRT.speacilRoute = from.path;}

                this.transitionName = toIndex < fromIndex ? 'page-left' : 'page-right';
            }
        },

        mounted(){

            let plug = this.$mapStore.plugInfo,
                appLoad = this.$store.state.appLoad;

            this.$router.onReady(() => {

                let callback = ()=>{

                    if(this.loadProgress) this.loadProgress = 100;

                    this.$nextTick(()=>{
                        this.$store.state.appLoad = 99;
                        this.isTransition = true;

                        let state = false;

                        //开启紧急逃生监控
                        let QueryEscapeStatus = ()=>{

                            getEscapeRoute((res,err)=>{
                                // console.log('getEscapeRoute',res);
                                if(!err){

                                    if(res){

                                        if(!state){

                                            //开启逃生
                                            this.$store.state.escapeState = true;

                                            //开启逃生通道
                                            if(!this.$BRT.$route.isExit && !this.escapeFixed){
                                                this.escapeMsgFixed = true;

                                                //记录
                                                state = true;
                                                // sessionStorage.setItem(`QueryEscapeStatus_${plug.buildingId}`,true);
                                            }

                                        }

                                    }else{
                                        state = false;
                                        if(this.$store.state.escapeState)this.$store.state.escapeState = false;
                                    }

                                }else{
                                    state = false;
                                    if(this.$store.state.escapeState)this.$store.state.escapeState = false;
                                }

                                setTimeout(QueryEscapeStatus,5000)

                            })

                        }

                        QueryEscapeStatus();
                    })

                }


                if(appLoad == 1){

                    if(!this.transitionTime){
                        callback()
                    }

                    else{

                        setTimeout(() => {
                            callback()
                        }, this.transitionTime);

                    }

                }

                else if(appLoad == 2){

                    if(this.transitionTime){
                        setTimeout(()=>{
                            callback && callback();
                        },this.transitionTime)
                    }else{
                        callback && callback();
                    }
                }

            });


            if(appLoad == 1){
                //加载动画
                let time = this.transitionTime / 100 || 10,
                    loadAnimation = ()=>{

                        if(this.loadProgress < 99){
                            this.loadProgress += 1;
                            setTimeout(loadAnimation,time)
                        }

                    }

                loadAnimation();
            }


        }
    }
</script>

<style lang="less">
    @import "./styles/index.less";

    .themBgColor{background-color: #0465ef !important;}
    .themFontColor{color: #0465ef !important;}


    @keyframes rotateFrames
    {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .parking-ocupy-fixed{

        .fixedByCover();
        .flexCenter();
        pointer-events: auto;
        background-color: @maskBgColor !important;
        z-index: 1000;
        color: @fontColorA2;

        >.wrap{
            width: 80%;

            text-align: center;
            border-radius: @radiusNumber;
            box-shadow: @shadowbox;
            background-color: @themeReverseColor;
            >.c-box{
                padding: @50px;
                >i{
                    font-size: @120px;
                }

                >.p1{
                    text-align: left;
                    margin: @32px 0px @10px 0px;
                    color: @fontColorV1;
                }
                >.p2{
                    text-align: left;
                }
            }

            >.b-box{
                display: flex;
                border-top: 1px solid @borderColorA2;

                >a{
                    flex: 1;
                    display: inline-block;
                    text-align: center;
                    padding: @32px 0px;
                    border-right: 1px solid @borderColorA2;
                    color: @themeColor;
                    &:last-child{
                        border-right: none;
                    }

                    &:active{
                        background-color: @bodyBgColor;
                    }
                }
            }
        }

    }

    .escape-fixed{
        .fixedByCover();
        .flexCenter();
        pointer-events: auto;
        background-color: @maskBgColor !important;
        z-index: 1000;

        >.wrap{

            text-align: center;
            >.box{
                display: inline-block;
                @var:50vw;
                width: @var;
                height: @var;
                border-radius: @var/2;
                background-color: @successColor;
                color: @themeReverseColor;
                .flexCenter();
                flex-direction: column;
                text-align: center;
                >i{
                    font-size: @120px;
                    display: block;
                }

                &:active{
                    opacity: .8;
                }

            }

            >.iconfont{
                display: inline-block;
                margin-top: @50px;
                @var:@80px;
                width: @var;
                height: @var;
                text-align: center;
                line-height: @var;
                border-radius: @var/2;
                background-color: @themeReverseColor;
                color: @fontColorA2;
                font-size: @40px;
                &:active{
                    opacity: .8;
                }
            }
        }

    }

    .escape-message-fixed{
        .fixedByCover();
        .flexCenter();
        pointer-events: auto;
        background-color: @maskBgColor !important;
        z-index: 10000;
        color: @fontColorA2;

        >.wrap{
            width: 60%;
            overflow: hidden;
            border-radius: @radiusNumber;
            background-color: @themeReverseColor;

            >.t{
                text-align: center;
                padding: @standartSpaceA4 0px;
                background-color: @successColor;
                color: @themeReverseColor;
                >i{font-size: @80px}
            }

            >.c{
                text-align: center;
                padding: @60px 0px;
                color: @fontColorA1;
            }

            >.b{
                border-top: 1px solid @borderColorA2;
                height: @80px;
                line-height: @80px;
                text-align: center;
                color: @successColor;
                &:active{
                    opacity: .8;
                }
            }
        }
    }

    // 预加载遮罩层
    .app-preload {
        z-index: 100000;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffff !important;
        background-image: url("./../public/images/loadBg.jpg");
        background-size: 100% 100%;

        &.fade-scale-enter-active,
        &.fade-scale-leave-active {
            transition: opacity .5s;
        }

        > .comm-icon {
            width: 50%;
            margin: 0 auto;
            position: relative;
            opacity: 0.85;

            >.logo{
                >img{
                    width: 100%;
                }
                margin-bottom: @150px;
            }


            >.progress{

                @var:@8px;
                text-align: center;
                padding: 0px @standartSpaceA4;

                >.rail{
                    height: @var;
                    overflow: hidden;
                    border-radius: @var/2;
                    background-color: @borderColorA1;

                    >i{
                        display: block;
                        height: inherit;
                        background-color: @themeColor;
                    }
                }

                >.txt{
                    font-size: @fontSizeA6;
                    color: @themeColor;
                    margin-top: @10px;
                }

            }

        }
    }

    .app-preload1 {
        z-index: 100000;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffff !important;

        &.fade-scale-enter-active,
        &.fade-scale-leave-active {
            transition: opacity .5s;
        }

        > .comm-icon {
            width: 90px;
            height: 90px;
            margin: 0 auto;
            position: relative;
            opacity: 0.85;

            > div {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }

            > .comm {
                background: url("../public/images/preload-02.png") center no-repeat;
                background-size: 80% auto;
                animation: rotateFrames 1s linear infinite;
            }

            > .icon {
                background: url("../public/images/preload-01.png") center no-repeat;
                background-size: 35px auto;
            }
        }
    }

</style>
